// =============================================================================
// perfil-regiao-tabs.ts — alternancia das 6 abas do Perfil da Regiao.
//
// Proveniencia: Sections.perfilRegiao._bindTabs (assets/unified-app.js 1074-1088).
// Abas: visao / eleicoes / demo / pertencimento / influencias / negocios.
// Clicar numa aba marca-a (estilos inline) e mostra apenas o painel
// correspondente (display block/none + classe .active). Fidelidade total.
// =============================================================================

import {
  bindPerfilListenerOnce,
  queryPerfilNodes,
  syncPerfilInlineTabs,
} from './perfil-regiao-dom';

/** Mostra o painel cujo data-panel casa com a aba clicada; esconde os demais. */
function togglePerfilPanels(activeTabKey: string): void {
  queryPerfilNodes<HTMLElement>('.u-perfil-panel').forEach((panel) => {
    const isTargetPanel = panel.dataset.panel === activeTabKey;
    panel.style.display = isTargetPanel ? 'block' : 'none';
    panel.classList.toggle('active', isTargetPanel);
  });
}

/**
 * Liga o clique de cada aba .u-perfil-tab (idempotente via bindOnce, chave 'perfil-tab').
 * Inicializa a sincronizacao com a aba ja marcada .active (ou a primeira).
 * Replica _bindTabs: ordem e selecao identicas ao original.
 */
export function bindPerfilTabs(): void {
  const tabButtons = queryPerfilNodes<HTMLElement>('.u-perfil-tab');
  const initialActive =
    document.querySelector<HTMLElement>('.u-perfil-tab.active') ?? tabButtons[0] ?? null;
  syncPerfilInlineTabs(tabButtons, initialActive);
  tabButtons.forEach((tabButton) => {
    bindPerfilListenerOnce(tabButton, 'click', 'perfil-tab', () => {
      syncPerfilInlineTabs(tabButtons, tabButton);
      togglePerfilPanels(tabButton.dataset.tab ?? '');
    });
  });
}
